const PostNotif = (url, body, resp) => {
    fetch(url, {
        method: 'POST', 
        body: JSON.stringify(body),
        headers:{'Content-Type' : 'application/json', 'charset' : 'UTF-8'},
        /* credentials: "same-origin" */})
    .then(response => {response.text().then(respuesta);
        function respuesta(data) {
            resp (data);
        }
    },error => {
        /* IntentosPost++;
        (IntentosPost > 5) ? IntentosPost = 0 : PostNotifjsx(url, body, (respuesta) => {
            resp(respuesta)
        }) */
        console.error('Ocurrió un error al cargar. Reintentando. ', error);
    })
}

export default PostNotif;


// WEBPACK FOOTER //
// ./src/shared/PostNotif.jsx